export default () => {
  // Navigation: sub sub navigation
  document.querySelectorAll('.subsub-navigation').forEach(nav => {
    nav.addEventListener('click', event => {
      const link = event.target.closest('.subsub-navigation-group > a');
      if (!link) return;

      event.preventDefault();
      const parentGroup = link.parentElement;
      const allGroups = parentGroup.parentElement.children;

      // Schließe alle anderen Gruppen
      Array.from(allGroups).forEach(group => {
        if (group !== parentGroup) {
          group.classList.remove('open');
        }
      });

      // Toggle aktuelle Gruppe
      parentGroup.classList.toggle('open');
    });
  });

  const toggleClosestLi = event => {
    event.preventDefault();
    const targetLi = event.target.closest('li');
    if (!targetLi) return;

    // Schließe alle aktiven Elemente in derselben Ebene
    const parentUl = targetLi.closest('ul');
    parentUl.querySelectorAll('li.has-active').forEach(li => {
      li.classList.remove('has-active');
    });

    // Toggle aktuelles Element
    targetLi.classList.toggle('open');

    // Markiere aktives Level0-Element
    if (targetLi.classList.contains('level0')) {
      targetLi.classList.add('has-active');
    }
  };

  // Initialisierung der Navigationselemente
  document.querySelectorAll('.subsub-navigation .parent').forEach(parentEl => {
    const navigation = parentEl.closest('.subsub-navigation');
    if (!navigation) return;

    // Öffne vordefinierte aktive Elemente
    navigation.querySelectorAll('.level0.parent.active, .level1.parent.active').forEach(levelEl => {
      levelEl.classList.add('open');
    });

    // Event-Listener für Platzhalter-Links
    navigation.querySelectorAll('.parent > a[href="#"]').forEach(link => {
      const liLink = link.closest('li').querySelector('a');
      liLink.removeEventListener('click', toggleClosestLi);
      liLink.addEventListener('click', toggleClosestLi);
    });
  });

  // Responsive Navigation
  document.querySelectorAll('.content-navigation .content-navigation-toggle').forEach(toggle => {
    toggle.addEventListener('click', event => {
      event.preventDefault();
      toggle.closest('.content-navigation').classList.toggle('open');
    });
  });
};